import { UiDefinition } from 'app/infrastructure/ui/types-uidefinition';

export const ACTION = {
  REQUEST_UI_DEFINITION: 'UI_DEFINITION:REQUEST_UI_DEFINITION',
  RECEIVE_UI_DEFINITION: 'UI_DEFINITION:RECEIVE_UI_DEFINITION',
  FAIL_UI_DEFINITION: 'UI_DEFINITION:FAIL_UI_DEFINITION'
};

export class RequestUiDefinition {
  public type: string = ACTION.REQUEST_UI_DEFINITION;
  constructor(public caseTypeId: number, public caseContextId: number) {
  }
}

export class ReceiveUiDefinition {
  public type: string = ACTION.RECEIVE_UI_DEFINITION;
  constructor(public caseTypeId: number, public caseContextId: number, public uiDefinition: UiDefinition, public eTag: string) {
  }
}

export class FailUiDefinition {
  public type: string = ACTION.FAIL_UI_DEFINITION;
  constructor(public caseTypeId: number, public caseContextId: number) {
  }
}
